import { StatefulCSS } from './../../../model/stateful_css';
import { Component, OnInit, EventEmitter, Output, Input, ChangeDetectionStrategy, AfterContentInit, ChangeDetectorRef, ElementRef } from '@angular/core';

export type DateIsAWhat = 'dow' | 'dom' | 'doy' | 'moy' | 'woy' | 'year';
export const dateIsAWhatMapShort = { dow: 'Day of Week', dom: 'Day of Month', doy: 'Day of Year', woy: 'Week of Year', moy: 'Month of Year', year: 'Year' };
export const dateIsAWhatMap = { dow: 'day of the week', dom: 'day of the month', doy: 'day of the year', woy: 'week of the year', moy: 'month of the year', year: 'year' };

export interface DateIsAPair {
  what: DateIsAWhat;
  which: number;
}

@Component({
  selector: 'app-date-is-a',
  templateUrl: './date-is-a.component.html',
  styleUrls: ['./date-is-a.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DateIsAComponent implements AfterContentInit {

  public isAWhat: DateIsAWhat;
  public whichWhat = 0;
  public minVal = 0;
  public maxVal = 6;
  public suffix = 'th';
  public requiresNthInput = false;
  public requiresYearInput = true;

  private lastVal: DateIsAPair = null;
  private _ready = false;
  private states: StatefulCSS = new StatefulCSS();

  @Input()
  public get value(): DateIsAPair {
    const pair: DateIsAPair = {
      what: this.isAWhat,
      which: this.whichWhat
    }
    return pair;
  }
  public set value(val: DateIsAPair) {
    if (this.lastVal !== null) {
      if (!!val) {
        if (this.lastVal.what === val.what) {
          if (this.lastVal.which === val.which) {
            return;
          }
        }
      }
    }
    if (!val) {
      val = {
        what: 'dow',
        which: 0
      }
    }

    this.lastVal = val;
    this.isAWhat = val.what;
    this.whichWhat = val.which;
    this.HandleWhatSelect(this.isAWhat);
    this.HandleWhich(val.which);
    this.Refresh();
  }
  @Output() valueChange = new EventEmitter<DateIsAPair>();

  private _filtered = false;
  @Input()
  set filtered(isFiltered:boolean) {
    this._filtered = isFiltered;
    if(!!this._filtered) {
      if(['dow','doy','woy'].indexOf(this.isAWhat) > -1) {
        this.isAWhat === 'dom';
      }
    }
    this.Refresh();
  }
  get filtered() {
    return this._filtered;
  }

  HandleWhatSelect(value) {
    this.requiresNthInput = true;
    this.requiresYearInput = false;

    switch (value) {
      case 'dow':
        this.minVal = 1;
        this.maxVal = 7;
        break;
      case 'dom':
        this.minVal = 1;
        this.maxVal = 31;
        break;
      case 'doy':
        this.minVal = 1;
        this.maxVal = 365;
        break;
      case 'moy':
        this.minVal = 1;
        this.maxVal = 12;
        break;
      case 'woy':
        this.minVal = 1;
        this.maxVal = 51
        break;
      case 'year':
        this.minVal = 1;
        this.maxVal = 4040;
        if (this.whichWhat < 1000) {
          this.whichWhat = new Date().getFullYear();
        }
        this.requiresNthInput = false;
        this.requiresYearInput = true;
        break;
    }
    this.whichWhat = Math.max(this.whichWhat, this.minVal);
    this.whichWhat = Math.min(this.whichWhat, this.maxVal);
    this.states.SetState(value)
    this.valueChange.emit(this.value);
    this.Refresh();
  }
  HandleWhich(which: string | number) {
    this.valueChange.emit(this.value);
    this.UpdateSuffix(which);
    this.Refresh();
  }
  UpdateSuffix(which: string | number) {
    const i = Number(which);
    const j = i % 10;
    const k = i % 100;
    if (j === 1 && k !== 11) {
      this.suffix = 'st';
      return;
    }
    if (j === 2 && k !== 12) {
      this.suffix = 'nd';
      return;
    }
    if (j === 3 && k !== 13) {
      this.suffix = 'rd';
      return;
    }
    this.suffix = 'th';
    this.Refresh();
  }

  constructor(private cdr: ChangeDetectorRef, private domNode: ElementRef) {
  }

  ngAfterContentInit(): void {
    this.value = undefined;
    this._ready = true;
    this.Refresh();
    this.states.SetPrefix('isa');
    this.states.SetMachine(this.domNode.nativeElement);
    this.states.AddState('dow');
    this.states.AddState('dom');
    this.states.AddState('doy');
    this.states.AddState('woy');
    this.states.AddState('moy');
    this.states.AddState('year');
    this.states.SetState(this.value.what);

  }
  Refresh() {
    if (this._ready === false) return;
    this.cdr.detectChanges();
  }

}
